<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
-->

<div class="cssLayoutRowStartCenter">
  <mat-form-field class="search-box">
    <mat-label>Search</mat-label>
    <input matInput [formControl]="filterControl" placeholder="Search" />
    @if (filterControl.value) {
    <button matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
      <mat-icon class="mdi-24px" fontIcon="mdi-close-circle-outline"></mat-icon>
    </button>
    }
  </mat-form-field>
  <div class="paginator">
    <mat-paginator #paginator [length]="filteredCardList?.length" [pageIndex]="pageIndex" [pageSize]="pageSize"
      [pageSizeOptions]="[5, 10, 15, 20, 25, 50, 100, 200]" (page)="paginatorEvent($event)"></mat-paginator>
  </div>
</div>

@if (!isLoading) {
<mat-accordion displayMode="flat">
  <section matSort (matSortChange)="sortChanged($event)" class="header-row">
    <div class="header-cell button-cell">
      <button mat-icon-button (click)="addOrEditCard(null); $event.stopPropagation()"
        style="outline: none; margin-left: 20px;" title="Add a Card" [disabled]="!canEdit">
        <mat-icon class="mdi-24px center-self" fontIcon="mdi-plus-circle"></mat-icon>
      </button>
    </div>
    <div class="header-cell five-cell" mat-sort-header="name">Name</div>
    <div class="header-cell three-cell" mat-sort-header="description">Description</div>
  </section>

  @for (card of displayedCards; track card.id) {
  <mat-expansion-panel disabled>
      <mat-expansion-panel-header class="row" (click)="togglePanel(card)">
        <div class="cell button-cell">
          <button mat-icon-button (click)="addOrEditCard(card)" style="outline: none;" title="Edit {{ card.name }}"
            [disabled]="!canEdit">
            <mat-icon class="mdi-24px center-self" fontIcon="mdi-square-edit-outline"></mat-icon>
          </button>
          <button mat-icon-button (click)="deleteCard(card)" style="outline: none;" title="Delete {{ card.name }}"
            [disabled]="!canEdit">
            <mat-icon class="mdi-24px center-self" fontIcon="mdi-trash-can-outline"></mat-icon>
          </button>
        </div>
        <div class="cell five-cell center-self">
          {{ card.name }}
        </div>
        <div class="cell three-cell center-self pad-top-bottom">
          {{ card.description }}
        </div>
      </mat-expansion-panel-header>
    </mat-expansion-panel>
  }
</mat-accordion>
}

@if (isLoading) {
<mat-card appearance="outlined" style="display: flex; justify-content: center; align-items: center;">
  <mat-progress-spinner color="primary" mode="indeterminate">
  </mat-progress-spinner>
</mat-card>
}
